import React from "react";
import { Box, Image } from "@chakra-ui/react";
export function SelectOptionAccessory({ accessory, }) {
    return (React.createElement(Box, { mr: 2 },
        accessory.type === "image" && (React.createElement(Image, { src: accessory.url, flex: "none", boxSize: "4", "aria-hidden": "true" })),
        accessory.type === "status" && (React.createElement(Box, { flex: "none", boxSize: "2", borderRadius: "full", bg: `${accessory.color}.600` }))));
}
